<template>
    <div>
    </div>
</template>

<script>
export default {
    name: 'BlogsPage',
}
</script>
<style scoped>

</style>